import axios from './upstreamAwareAxios';
import { getAuth } from '../providers/AppAuthProvider';
import { Resources } from '../resources/resource';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = Resources.swapConfigRango;

type RangoConfig = {
  referralCode: string;
};

type ApiRangoConfig = { config: { referralCode: string } };

async function buildHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

export async function getRangoConfig(params?: {
  address?: string;
  chainId?: number;
  signal?: AbortSignal;
}): Promise<RangoConfig> {
  const { address, chainId, signal } = params ?? {};
  const headers = await buildHeaders();
  const url = `${baseUrl}/${resource}`;

  const res = await axios.get<ApiRangoConfig>(url, {
    headers,
    signal,
    params: { address, chainId },
    paramsSerializer: (p) =>
      new URLSearchParams(
        Object.entries(p).filter(([, v]) => v != null) as [string, string][]
      ).toString(),
  });

  return { referralCode: res.data.config.referralCode };
}

// export async function getRangoConfig(address?: string, chainId?: number) {
//   const url = `${baseUrl}/${resource}`;
//   const headers = await buildHeaders();

//   return axios.get<{ data: RangoConfig }>(url, {
//     headers,
//   });
// }

export async function updateRangoConfig(code: any) {
  const url = `${baseUrl}/${resource}`;
  const headers = await buildHeaders();

  return axios.post<{ data: RangoConfig }>(url, {
    headers,
  });
}
